// Dollar label for an agent session/turn cost in cents (issue #654), shared by
// the session list, the transcript and the Workspace panel. Below one cent
// collapses to "<$0.01" so a cheap session doesn't read as "$0.00", which is
// reserved for a cost that is genuinely zero.
export function agentCostLabel(cents: number): string {
  if (cents === 0) return '$0.00'
  if (cents < 1) return '<$0.01'
  return `$${(cents / 100).toFixed(2)}`
}
